import { SignatureOutlined } from '@ant-design/icons';
import {
  createCommonFormSchema,
  CustomWarningsRule,
  InputCommonTranslationSchema,
  RequiredRule,
  tran,
  VoteType,
  VoteTypeMetaKey,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
  type IWidgetType,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { type IVoteWidget } from './IVoteWidget';
import { VoteWidgetComponent } from './VoteWidgetComponent';
import {
  VoteWidgetConfigComponent,
  VoteWidgetConfigSchema,
} from './VoteWidgetConfigComponent';

/**
 * Definizione del Widget di voto
 */
export const VoteWidgetType: IWidgetType<IVoteWidget> = {
  type: WidgetType.Vote,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Pulsante di Voto',
  icon: <SignatureOutlined />,
  hasValue: false,
  formComponent: VoteWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(
      // Il tipo di votazione è dichiarato sullo schema del pulsante e letto da
      // extractVotes per estrarre i voti come CTS (candidati) o CS (liste).
      yup.string().meta({ [VoteTypeMetaKey]: widget.voteType ?? VoteType.CTS }),
      widget,
    ),
  previewComponent: VoteWidgetComponent,
  configValidator: VoteWidgetConfigSchema,
  configComponent: VoteWidgetConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    buttonText: tran.string(),
  }),
  configOptions: {
    hideDirectives: true,
  },
  rules: [RequiredRule, CustomWarningsRule],
};
